<template>
    <page>
        <module :title="id ? '编辑新人活动' : '新建新人活动'">
            <c-form ref="form">
                <c-form title="基础信息">
                    <c-form-item type="hidden" name="activity_id" v-model="activity_id" required></c-form-item>
                    <!--默认与其他活动互斥-->
                    <c-form-item type="hidden" name="activity_mutex_flag" value="1"></c-form-item>
                    <!--默认【共享库存】-->
                    <c-form-item type="hidden" name="ind_activity_stock" value="0"></c-form-item>
                    <c-form-item type="input" label="活动名称"  name="activity_name"  maxlength="20" required></c-form-item>
                    <c-form-item type="datetime" label="活动时间" start-name="begin_date" end-name="end_date" required></c-form-item>
                    <c-form-item type="number" label="限购数量" decimal="0" :limit="[1,99]" v-model="purchase_limit" name="purchase_limit"
                                 input-unit="件"
                                 required word="仅限购数量享受活动价，超出部分以原价销售（该原价是无活动的价格）"></c-form-item>
                    <c-form-item type="input" label="活动标签" name="tags" maxlength="4" word="标签最多输入4个字符；该标签将显示在商品列表、SKU弹窗中"></c-form-item>
<!--                    <c-form-item type="radio" label="活动预告设置" value="-1"  name="activity_notice" v-model="activityNotice" :options="activityNoticeOptions"
                                 required word="活动预告期间，商品详情页价格上方将会展示活动标题，开始时间和折扣力度。" ></c-form-item>
                    <c-form-item type="number" v-if="activityNotice == 1" decimal="1" :limit="[0.1,9999]" v-model="activityNoticeTime"  name="activity_notice_time" input-unit="小时"></c-form-item>-->
                </c-form>
                <c-form title="活动商品">
                    <c-form-item>
                        <m-operate>
                            <c-button color="gray" hollow @click="$refs.productSelector.open()">添加商品</c-button>
                            <c-button color="gray" hollow @click="setLimit">批量填写活动价</c-button>
                        </m-operate>

                        <c-table ref="productList" v-model="productList" height="auto" :paging="false" border>
                            <c-table-column
                                    type="selector"
                            ></c-table-column>

                          <c-table-column
                              label="商品信息"
                              name="product_name"
                              width="250"
                          >
                            <template v-slot="{data}">
                              <div class="flex-center">
                                <c-image :src="oss(data.product_img_url, 46, 46)" size="46" preview></c-image>
                                <p class="flex-grow ellipsis-2" style="margin-left: 12px;">
                                    <span v-if="data.product_itemnumber">{{data.product_itemnumber}} - </span>
                                    {{data.product_name}}
                                </p>
                              </div>
                            </template>
                          </c-table-column>

                          <c-table-column
                                    label="原价"
                                    name="product_price"
                                    width="130"
                            >
                                <template v-slot="{data}">￥{{data.product_price}}</template>
                            </c-table-column>

                            <c-table-column
                                    label="活动价"
                                    width="80"
                            >
                                <template v-slot="{data}">
                                    <c-input type="number" decimal="2" v-model="data.sale_price" :limit="[0, data.product_price]" width="60"  style="margin: 0 5px;"></c-input>
                                </template>
                            </c-table-column>

                            <c-table-column
                                    type="button"
                                    fixed="right"
                                    label="操作"
                                    width="140"
                            >
                                <template v-slot="row">
                                    <c-table-button @click="row.remove()">删除</c-table-button>
                                </template>
                            </c-table-column>
                        </c-table>
                    </c-form-item>
                </c-form>
            </c-form>

            <template slot="button">
                <c-button v-show="editFlag" power="b_activity_new_edit" size="m" @click="submit()">提交保存</c-button>
            </template>
        </module>

        <c-dialog ref="limitDialog" title="批量填写活动价" width="400" height="150" @resolve="setLimitHandle">
            <c-form>
                <c-form-item  label="活动价" required>
                    <c-input  v-model="sale_price" decimal="2" :limit="[0.01,99999]" width="200" type="number" style="margin: 0 5px;"></c-input>
                </c-form-item>
            </c-form>
        </c-dialog>

      <product-selector ref="productSelector" multiple @resolve="productSelectHandle"></product-selector>
    </page>
</template>

<script>
    import productSelector from '@/components/service/product_selector.vue'
    export default {
        name: 'activity_new_edit',

        components: {
            productSelector
        },

        props: {
            id: String
        },

        data() {
            return {
                activityNoticeTime: 0,
                activityNotice: -1,
                activityNoticeOptions: [{
                  name: '立即预告',
                  value: 0
                },{
                  name: '不预告',
                  value: -1
                },{
                    name: '提前预告',
                    value: 1
                }],
                activity_id: '',
                sale_price: 0,
                new_user_limit: '',
                min_price_order: '',
                productList: [],
                editFlag: true,
                purchase_limit:1
            }
        },

        watch: {
            id() {
                this.getActivityDetail();
            }
        },

        mounted() {
            this.id && this.getActivityDetail();
        },

        methods: {
            getActivityDetail() {
                this.request({
                    url: '/activity/new/detail',
                    data: {
                        id: this.id
                    },
                    loading: true,
                    success: data => {
                        this.$refs.form.set(data);
                        if(data.start_state == "1"){
                            this.editFlag = false;
                        }
                        this.activityNoticeTime = data.activity_notice_time;
                        this.purchase_limit = data.purchase_limit;
                        this.productList = data.product_list;
                    }
                });
            },
            productSelectHandle(list) {
                list = list.filter(item => {
                    return !this.productList.find(row => {
                        return row.product_id == item.product_id;
                    });
                });
                list.forEach(item=>{
                    item.state = 1;
                    item.min_price_order = 1;
                })
                //检查商品时间是否和其他活动重叠
                this.productList = this.productList.concat(list);
            },
            setLimit() {
                this._limit = this.$refs.productList.getRow('selected');
                if (!this._limit.length) {
                    this.$message({
                        text: '请选择商品'
                    });
                    delete this._limit;
                    return;
                }
                this.sale_price = 0;
                this.$refs.limitDialog.open();

            },
            setLimitHandle(stop) {
                if (!this.sale_price) {
                    stop();
                    this.$message({
                        text: '请填写商品活动售价'
                    });
                    return;
                }
                this._limit.forEach(row => {
                    row.update({
                        sale_price: this.sale_price
                    });
                });
            },
            submit() {
                this.$refs.form.submit({
                    url: this.id ? '/activity/new/edit' : '/activity/new/add',
                    rule: {
                        activity_name: '请填写活动名称',
                        begin_date: '请选择活动时间',
                        product_list: [{
                            type: 'function',
                            fun: () => {
                                return this.productList.length;
                            },
                            word: '请选择活动商品'
                        }],
                        product_config: [{
                            type: 'function',
                            fun: () => {
                                return !this.productList.find(item => {
                                    if(item.sale_price == 0){
                                        return false
                                    }
                                    return !item.sale_price;
                                });
                            },
                            word: '请设置商品活动价'
                        }]
                    },

                    dataFormatter: data => {
                        this.id && (data.id = this.id);
                        data.product_list = Array.from(this.productList, item => {
                            return {
                                product_id: item.product_id,
                                product_sku: item.product_sku,
                                product_name: item.product_name,
                                sale_price: Number.parseFloat(item.sale_price)
                            }
                        });
                        data.activity_notice = -1;//默认不进行预告
                        return data;
                    },

                    success: (data,obj) => {
                        if(obj != null && obj.length !=0){
                            var res = "【";
                            obj.forEach(item=>{
                                res+=item+","
                            })
                            res = res.substring(0,res.length-1);
                            res+="】"

                            this.$message({
                                text: '保存成功,存在以下商品和其他活动时间冲突未能添加成功'+res.toString(),
                            });
                        }else{
                            this.$message({
                                text: "保存成功",
                            });
                        }
                        this.$bus.$emit('activityNewList.update');
                        this.redirectTo('/activity_new');
                    }
                })
            }
        }
    }
</script>

<style lang="stylus" scoped>
  .limit {
    .item {
      margin-right: 16px;

      label {
        margin-right: 8px;
      }
    }
  }
</style>